export default __webpack_public_path__ + "static/media/EmbPlus.f4d2df83.svg";